module.exports = __webpack_public_path__ + "static/WEDDING E&M-93-49a530e2695ea352faec3d32b0969b5d.jpg";